module.exports = __webpack_public_path__ + "img/hr-assembling-machine-3-pipe-N.6dab3616.png";